import React from "react"
import { ORDER_MODE } from "../OrderMode"

import style from "./index.module.sass"

function FirstSlot(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { slot, orderMode } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderDeliverySlot(timeSlot) {
    if (timeSlot) {
      const { start_time } = timeSlot

      return (
        <div className="text-center">
          <div className={style.firstDelivery}>{start_time}</div>
          <div className={style.firstDeliveryLabel}>
            {I18n.t("pages.locations.venues.venue_box.delivery_from")}
          </div>
        </div>
      )
    } else {
      return I18n.t("pages.locations.venues.venue_box.ended_deliveries")
    }
  }

  function renderPickupSlot(timeSlot) {
    if (timeSlot) {
      const { picking_times = [] } = timeSlot

      return (
        <div className="text-center">
          <div className={style.firstDelivery}>{picking_times[0]}</div>
          <div className={style.firstDeliveryLabel}>
            {I18n.t("pages.locations.venues.venue_box.takeaway_from")}
          </div>
        </div>
      )
    } else {
      return I18n.t("pages.locations.venues.venue_box.ended_takeaway_slots")
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  switch (orderMode) {
    case ORDER_MODE.DELIVERY:
      return renderDeliverySlot(slot)
    case ORDER_MODE.PICKUP:
      return renderPickupSlot(slot)
    default:
      return ""
  }
}

export default FirstSlot
